import { Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(value, campo): any {
    return value.sort((obj1, obj2) => {
      if (obj1.value[campo] > obj2.value[campo]) {
        return 1;
      }
      if (obj1.value[campo] < obj2.value[campo]) {
        return -1;
      }
      return 0;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/sort.pipe.ts